// Tipos válidos: .pdf, .doc, .docx, .txt, .ppt, .xls, .xlsx, .csv, .mp3, .wma, .mp4, .wmv, .avi, .png, .jpeg, .raw.

const acceptedFiles = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessing",
  "text/plain",
  "application/vnd.ms-powerpoint",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "audio/mpeg",
  "audio/x-ms-wma",
  "video/x-ms-asf",
  "video/mp4",
  "video/x-ms-wmv",
  "video/x-msvideo",
  "image/png",
  "image/jpeg",
  "image/x-dcraw",
];

function findObjectInChildren(arr, id) {
  let result;
  for (let i = 0; i < arr.length; i++) {
    if (String(arr[i].id) === String(id)) {
      result = arr[i];

      return result;
    }
    if (arr[i].children) {
      result = findObjectInChildren(arr[i].children, id);
      if (result) break;
    }
  }
  return result;
}

function listAllParents(documentTree, doc) {
  const result = [];

  let parent = doc.parent;

  while (parent) {
    const docParent = findObjectInChildren(documentTree, parent.id);

    if (docParent) {
      result.splice(0, 0, docParent);
    }

    parent = docParent?.parent;
  }

  return result;
}

function addChildrenOnTree(tree, children, parentId) {
  if (!tree || tree.length <= 0) {
    return;
  }

  for (let i = 0; i < tree.length; i++) {
    if (String(tree[i].id) === String(parentId)) {
      tree[i].children = children;
      return;
    }
    addChildrenOnTree(tree[i].children, children, parentId);
  }
}

function buildTree(tree, children) {
  const parentIds = [...new Set(children.map((c) => c.parent.id))];
  for (let i = 0; i < parentIds.length; i++) {
    const parentId = String(parentIds[i]);
    const currentChildren = children.filter(
      (c) => String(c.parent.id) === parentId,
    );

    addChildrenOnTree(tree, currentChildren, parentId);
  }
}

export {
  acceptedFiles,
  findObjectInChildren,
  listAllParents,
  addChildrenOnTree,
  buildTree,
};
